import L from 'leaflet';
import React, {Component, Fragment} from 'react';
import {isObservableArray} from 'mobx';
import {observer, inject} from 'mobx-react';
import {Map, Marker, Polyline, Polygon, TileLayer} from 'react-leaflet';
import {Link} from 'react-router-dom';
import 'leaflet-touch-helper';
import Mousetrap from 'mousetrap';
import {getIconSrc} from "../../utils/Utils";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faInfo} from '@fortawesome/free-solid-svg-icons'

import Button from "../../components/Button";

import ZoomDependentTileLayer from "./components/ZoomDependentTileLayer";
import BottomContainerDesktop from "./components/BottomContainerDesktop";
import BottomContainerMobile from "./components/BottomContainerMobile";
import IconDrop from "./components/DrawerContainer/components/IconDrop";
import PopupContainer from "./components/PopupContainer";
import PolylineDraw from "./components/PolylineDraw";
import PolygonDraw from "./components/PolygonDraw";

import './leaflet.css';

import FeatureGroup from "react-leaflet/es/FeatureGroup";
import {withNavigate} from "../../WithNavigation";
import Landing from "../Landing";

const LandingWithNavigation = withNavigate(Landing);
const BottomContainerDesktopWithNavigation = withNavigate(BottomContainerDesktop);
const BottomContainerMobileWithNavigation = withNavigate(BottomContainerMobile);

@inject("appStore")
@observer
class MapContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hoveredElement: null
        };
    }

    componentDidMount = () => {
        Mousetrap.bind(['escape'], this.props.appStore.clearPending);
    };

    componentWillUnmount = () => {
        Mousetrap.unbind(['escape'], this.props.appStore.clearPending);
    };

    componentDidUpdate() {
        if (this.polygonLayer) {
            this.polygonLayer.leafletElement.bringToBack(); // Keep polygons underneath all other shapes/markers
        }
    }

    getTileLayerUrl = (layerName) => {
        return this.props.appStore.appConfig.map.baseLayers[layerName].url;
    };

    //todo:
    /*getOverlays = () => {
        /!*if (this.props.appStore.appConfig.map.overlays) {
            let resDiv = '';
            this.props.appStore.appConfig.map.overlays.forEach(function (elem, i, arr) {
                let currDiv = <TileLayer attribution={elem.name} url={elem.url}/>;
                resDiv += currDiv;
            });
            return resDiv;
            /!*return this.props.appStore.appConfig.map.overlays.map(elem => {
                console.log('overlays: ' + elem.name);
                return (<TileLayer
                    attribution={elem.name}
                    url={elem.url}
                />);
            });*!/
        }*!/
    };*/

    handleElementClick = (element) => {
        if (this.props.appStore.pendingState.element) return;
        this.props.appStore.elementStore.makePendingElement(element, true);
        this.props.appStore.setSavePopup(true);
    };

    onMapMount = (map) => {
        if (map) {
            map.leafletElement._container.setAttribute('tabindex', -1);
            this.props.appStore.configureElement(map.leafletElement);
        }
    };

    touchHelper = (element) => {
        if (element && this.props.appStore.mapState.element) {
            L.path.touchHelper(element.leafletElement, {extraWeight: 25}).addTo(this.props.appStore.mapState.element);
        }
    };

    onViewPortChange = (viewport) => {
        if (!viewport || !viewport.center) return;
        // console.log('onViewPortChange: '+viewport.zoom);
        if (this.props.appStore.appConfig.map) {
            this.props.appStore.setMapViewport({
                center: {
                    lat: viewport.center[0],
                    lng: viewport.center[1]
                },
                zoom: viewport.zoom
            });
        }
    };

    returnLeafletIcon = (icon) => {
        return new L.divIcon({
            html: `<img style="background-color: ${icon.color}" alt="${icon.text} Marker" src="${getIconSrc(icon.image)}"/>`,
            iconSize: new L.Point(45, 45),
            className: 'leaflet-div-icon'
        });
    };

    componentDidCatch(error, info) {
    }

    getBaseLayers() {
        return (<TileLayer
            attribution="MapBox"
            url={this.getTileLayerUrl(this.props.appStore.mapState.mode)}
        />);
    }

    getOverlays() {
        const {mapTilerOverlays} = this.props.appStore.appConfig.map;
        if (!mapTilerOverlays || mapTilerOverlays.length === 0) return null;
        const {maxZoom} = this.props.appStore.getMapZooms();
        const tileSets = mapTilerOverlays.map((m) => {
            return {
                url: m.url,
                zoom: +m.zoom[0]
            };
        });
        return (<ZoomDependentTileLayer
            maxZoom={maxZoom}
            tileSets={tileSets}
            attribution="Sasaki"
        />);
        // if (this.props.appStore.appConfig.map.overlays && this.props.appStore.appConfig.map.overlays.layers && this.props.appStore.appConfig.map.overlays.layers.length > 0) {
        //     return this.props.appStore.appConfig.map.overlays.layers.map((elem, index) => {
        //         if (!elem.url) return '';
        //         return (<TileLayer
        //             attribution={elem.name ? elem.name : 'location - ' + index}
        //             url={elem.url}
        //         />);
        //     });
        // }
        // return '';
    }

    getOverlayUrl = () => {
        return this.props.appStore.appConfig.map.overlays.layers[0].url;
    };


    render() {
        const mapZooms = this.props.appStore.getMapZooms();
        if (this.props.appStore.introModal) {
            return (
                <LandingWithNavigation appStore={this.props.appStore}/>
            )
        }

        function handleclick() {


        }

        const standalone = this.props.appStore.standalone;

        return (
            <div className={(this.props.appStore.isMobile) ? "MapContainer mobile" : "MapContainer desktop"}>
                <Map
                    id={"leafletMapContainer"}
                    ref={this.onMapMount}
                    wheelPxPerZoomLevel={250}
                    onViewportChanged={this.onViewPortChange}
                    viewport={this.props.appStore.appConfig.map.viewport}
                    zoomControl={false}
                    minZoom={mapZooms.minZoom}
                    maxZoom={mapZooms.maxZoom}
                    editable={true}
                    className={(this.props.appStore.placingIconMode ? 'placingIconState' : 'viewMode') + (this.props.appStore.pendingState.editing ? ' editMode' : '')}
                    doubleClickZoom={!this.props.appStore.pendingState.element}
                >

                    {!this.props.appStore.appConfig.map.nonSpatial && this.getBaseLayers()}
                    {this.getOverlays()}

                    {/*appStore.pendingElement('icon')*/}
                    {this.props.appStore.pendingState.element &&
                    this.props.appStore.pendingState.element.type === 'marker' &&
                    <IconDrop/>
                    }

                    {/*appStore.nonPendingElements('icon')*/}
                    {this.props.appStore.elementStore.elements.map((element, index) =>
                        (this.props.appStore.elementStore.isNotPending(element) &&
                            element.type === 'marker' &&
                            <Marker
                                key={element.uuid}
                                position={element.position}
                                icon={this.returnLeafletIcon(element.icon)}
                                draggable={false}
                                onClick={() => this.handleElementClick(element)}
                            >
                            </Marker>
                        ))}


                    {this.props.appStore.pendingState.element &&
                    this.props.appStore.pendingState.element.type === 'polyline' &&
                    <PolylineDraw/>
                    }

                    {this.props.appStore.elementStore.elements.map((element, index) =>
                        (this.props.appStore.elementStore.isNotPending(element) &&
                            element.type === 'polyline' &&
                            <Fragment key={element.uuid}>
                                <Polyline
                                    positions={element.position.slice()}
                                    color={"#000"}
                                    className={"polyline-clickarea"}
                                    onClick={() => this.handleElementClick(element)}
                                    onmouseover={() => {
                                        if (!this.props.appStore.pendingState.element) {
                                            this.setState({hoveredElement: element})
                                        }
                                    }}
                                    onmouseout={() => this.setState({hoveredElement: null})}
                                    weight={20}
                                    opacity={0}
                                />
                                <Polyline
                                    positions={element.position.slice()}
                                    color={element.icon.color}
                                    className={"polyline"}
                                    weight={this.state.hoveredElement === element ? 8 : 3}
                                    onClick={() => this.handleElementClick(element)}
                                />
                            </Fragment>
                        ))}


                    {this.props.appStore.pendingState.element &&
                    this.props.appStore.pendingState.element.type === 'polygon' &&
                    <PolygonDraw/>
                    }

                    <FeatureGroup ref={(layer) => this.polygonLayer = layer}>
                        {this.props.appStore.elementStore.elements.map((element, index) =>
                            (this.props.appStore.elementStore.isNotPending(element) &&
                                element.type === 'polygon' &&
                                <Polygon
                                    key={index}
                                    positions={element.position.slice()}
                                    color={element.icon.color}
                                    className={"polygon"}
                                    onClick={() => this.handleElementClick(element)}
                                >
                                </Polygon>
                            ))}
                    </FeatureGroup>

                    {this.props.appStore.pendingState.element && this.props.appStore.pendingState.savePopup &&
                    <div>
                        <PopupContainer isMobile={this.props.appStore.isMobile} appStore={this.props.appStore}/>
                    </div>
                    }

                </Map>

                {!this.props.appStore.isMobile &&
                <BottomContainerDesktopWithNavigation
                                        emptyResponseRoute={this.props.emptyResponseRoute}/>
                }

                {this.props.appStore.isMobile &&
                <BottomContainerMobileWithNavigation  emptyResponseRoute={this.props.emptyResponseRoute}/>
                }

                {/*   {<MapButtons/>}*/}

               {/* {!this.props.appStore.standalone &&

                <Button className="landingButton" aria-hidden="true" onClick={() => {
                    appStore.setIntroModal(true);
                    let fSlash = '';
                    if (!window.location.href.endsWith('/')) {
                        fSlash = '/';
                    }
                    window.location.href = window.location.href + fSlash + 'info';
                }
                }>
                    <FontAwesomeIcon icon={faInfo}/>
                </Button>
                }
                {
                    this.props.standalone  &&
                    <Link
                        aria-label="Info"
                        to={`/info`}>
                        <Button className="landingButton" aria-hidden="true">
                            <FontAwesomeIcon icon={faInfo}/>
                        </Button>
                    </Link>
                }*/}
                <Link
                    aria-label="Info"
                    to={`/info`}>
                    <Button className="landingButton" aria-hidden="true">
                        <FontAwesomeIcon icon={faInfo}/>
                    </Button>
                </Link>

            </div>
        );
    }
}

export default MapContainer;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/index.js